import { productImgs } from "contains/fakeData";
import productVariantImg2 from "images/products/v2.jpg";
import productVariantImg3 from "images/products/v3.jpg";
import productVariantImg4 from "images/products/v4.jpg";
import productVariantImg5 from "images/products/v5.jpg";
import productVariantImg6 from "images/products/v6.jpg";
//
import productSport1 from "images/products/sport-1.png";
import productSport2 from "images/products/sport-2.png";
import productSport3 from "images/products/sport-3.png";
import productSport4 from "images/products/sport-4.png";
import productSport5 from "images/products/sport-5.png";
import productSport6 from "images/products/sport-6.png";
import productSport7 from "images/products/sport-7.png";
import productSport8 from "images/products/sport-8.png";

//

export interface ProductVariant {
  id: number;
  name: string;
  thumbnail?: string;
  color?: string;
  featuredImage: string;
}

export interface Market {
 
  email: string;
  username: string;
}

export interface Media {
  id: number;
  name: string;
  path: string;
}

export type ShippingValue =  {
  type:  'shipping' | 'return' | 'delivery' | 'refunds';
  message: string 
}


interface Status {
  id: number
  value: string
}

interface Size {
  id: number
  value: string
}
interface Color {
  id: number
  color: string
}
export interface Product {
  id: number;
  name: string;
  price: number;
  thumb: string;
  medias?: Media[];
  description: string;
  category: string;
  tags: string[];
  link: "/product-detail/";
  variants?: ProductVariant[];
  variantType?: "color" | "image";
  sizes?: Size[];
  size?: Size[];
  colors: Color[];
  allOfSizes?: string[];
  status: Status;
  status_id: number;
  likes_count?: number,
  market?: Market
  shipping?: ShippingValue[]
  discount?: number
}


export const PRODUCTS: Product[] = [

  ];

